"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAnalyticsComponentInstance = exports.WebAnalyticsComponent = void 0;
const app_1 = require("app");
class WebAnalyticsComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = 'body';
    }
    BeforeInit() {
        if (!(0, app_1.isDataLayerSet)()) {
            return;
        }
        // collect commonContext
        const urlObj = app_1.UrlService.GetObjectFromUrlString(window.location.search.toLowerCase());
        // collect pageContext
        const element = document.getElementById('structured-data');
        const strJSONData = element ? element.innerHTML : null;
        const parsedData = strJSONData ? app_1.JSONService.parse(strJSONData) : null;
        const gtmData = app_1.AttrService.data(this.el[0], 'gtm');
        let language;
        let type;
        let unique_id;
        let name;
        let image_link;
        let description;
        let category;
        let markets;
        let segments;
        if (parsedData && parsedData.tags) {
            markets = this.selectGroup(parsedData.tags, 'markets:');
            segments = this.selectGroup(parsedData.tags, 'segments:');
        }
        if (parsedData) {
            language = parsedData.locale;
            type = parsedData.type;
            image_link = parsedData.image;
            description = parsedData.description;
        }
        if (gtmData) {
            unique_id = gtmData.UniqueId;
            name = gtmData.Name;
            category = gtmData.Category;
        }
        const commonContext = {
            language,
            user_id: urlObj.sid,
        };
        app_1.GTM.webAnalytics.pushCommonContext(commonContext);
        const pageContext = {
            business_unit: segments,
            category,
            description,
            image_link,
            market: markets,
            name,
            type,
            unique_id,
            url: window.location.href,
        };
        app_1.GTM.webAnalytics.pushPageContext(pageContext);
        // collect productContext
        const productContext = {};
        app_1.GTM.webAnalytics.pushProductContext(productContext);
    }
    selectGroup(tags, selector) {
        if (!tags) {
            return null;
        }
        const selectorRegExp = new RegExp(`^${selector}`);
        return tags.reduce((accumulator, currentValue) => {
            if (currentValue && selectorRegExp.test(currentValue)) {
                accumulator.push(currentValue.slice(selector.length));
            }
            return accumulator;
        }, []);
    }
}
exports.WebAnalyticsComponent = WebAnalyticsComponent;
exports.WebAnalyticsComponentInstance = new WebAnalyticsComponent();
